import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
const DateTimeDisplay = ({ value, type, isDanger }) => {
  return (
    <Card sx={{ width: '100%' }}>

      <CardContent>
        <Typography gutterBottom variant="h5" component="div" style={{ color: '#103468' }}>
          {value}
        </Typography>
        <Typography variant="body2" style={{ color: 'white', backgroundColor: "#81a4c7" }}>
          {type}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default DateTimeDisplay;
